<template>
  <div class="add-poll">
    <Header class="md:block hidden" />
    <AddPoll />
    <Footer class="md:block hidden" />
    <MobileFooter class="block md:hidden" />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/header/TopBarMinimal.vue";
import AddPoll from "@/components/addpoll/AddPoll.vue";
import Footer from "@/components/footer/Footer.vue";
import MobileFooter from "@/components/footer/mobile/MobileFooter.vue";

export default {
  name: "add-poll",
  components: {
    Header,
    AddPoll,
    Footer,
    MobileFooter
  }
};
</script>
